import React from 'react';
import PropTypes from 'prop-types';

const Resource = ({ src, alt = '', title, description, inverted }) =>
  <div className="resource">
    <div className={inverted ? 'inverted asset' : 'asset'}>
      <div className="asset-image-wrapper">
        <img src={src} alt={alt} />
      </div>
    </div>
    {title && <h5 className="resource-title">{title}</h5>}
    {description && <p className="resource-description">{description}</p>}
  </div>;

Resource.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  inverted: PropTypes.boolean
};

export default Resource;



// WEBPACK FOOTER //
// ./src/pages/press/components/Resource/Resource.js